import React from 'react';
import {FilterType} from "../data/FilterList";
import FilterItem from "./FilterItem";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {library, IconProp} from '@fortawesome/fontawesome-svg-core'

/* import all the icons in Free Solid, Free Regular, and Brands styles */
import {fas} from '@fortawesome/free-solid-svg-icons'
import {far} from '@fortawesome/free-regular-svg-icons'
import {fab} from '@fortawesome/free-brands-svg-icons'

// @ts-ignore
const filterIcon: IconProp = 'fa-solid fa-filter'

library.add(fas, far, fab)


export default function Filter({filters, setFilters}: {
    filters: any,
    setFilters: any
}) {
    function handleFilterToggle(id: string) {
        // https://www.youtube.com/watch?v=ck9W2A77taU&list=PLSsAz5wf2lkKm0BG9wUWWSgYWBzDa-dFs&index=42
        const newFilters = filters.map((filterLocal: any) => filterLocal.id === id ? {
            ...filterLocal,
            active: !filterLocal.active
        } : filterLocal)
        setFilters(newFilters);
    }

    return (
        <div className="filter-content" >
            <div className="filter-inner-content u-px-1">
                <h3>Status</h3>
                <ul className='u-pb-1'>
                    {filters.map((filter: FilterType) => {
                        return filter.type === 'status' &&
                            <FilterItem key={filter.id} handleFilterToggle={handleFilterToggle}
                                        filter={filter}></FilterItem>
                    })}
                </ul>

                <h3>Length</h3>
                <ul className='u-pb-1'>
                    {filters.map((filter: FilterType) => {
                        return filter.type === 'length' &&
                            <FilterItem key={filter.id} handleFilterToggle={handleFilterToggle}
                                        filter={filter}></FilterItem>
                    })}
                </ul>

                {/*Todo: make each dynamic + json? */}
                <h3>Relationship</h3>
                <ul>
                    {filters.map((filter: FilterType) => {
                        return filter.type === 'relationship' &&
                            <FilterItem key={filter.id} handleFilterToggle={handleFilterToggle}
                                        filter={filter}></FilterItem>
                    })}
                </ul>

                {/*<h3>Tags</h3>*/}
                {/*<ul id="tags-container">*/}
                {/*    {filters.map((filter: FilterType) => {*/}
                {/*        return filter.type === 'tags' &&*/}
                {/*            <FilterItem key={filter.id} handleFilterToggle={handleFilterToggle} filter={filter}></FilterItem>*/}
                {/*    })}*/}
                {/*</ul>*/}
            </div>
        </div>
    )
}